import { FC } from 'react';

import { YandexDirectReportType } from 'utils/constants/admin';

import { Text, VSpacing } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import { DownloadButton } from 'components/Admin/YandexDirectReport/DownloadButton/DownloadButton';

const TrlKeys = {
    title: 'admin.directReport.refund.title',
};

const REFUND_REPORT_DOWNLOAD_URL = '/api/v1/backoffice/yandex_refund_report';

export const RefundReport: FC = () => {
    const trl = useTrls();

    return (
        <>
            <Text typography="title-4-semibold">{trl(TrlKeys.title)}</Text>
            <VSpacing default={24} />
            <DownloadButton downloadUrl={REFUND_REPORT_DOWNLOAD_URL} reportType={YandexDirectReportType.REFUND} />
        </>
    );
};
